import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import back_n from "./Image/back_n.gif";
import back_o from "./Image/back_o.gif";
import back_d from "./Image/back_d.gif";
import principle_n from "./Image/principle_n.gif";
import tutorials_n from "./Image/tutorials_n.gif";
import clue_n from "./Image/clue_n.gif";
import solution_n from "./Image/solution_n.gif";
import solution_o from "./Image/solution_o.gif";
import solution_d from "./Image/solution_d.gif";
import next_n from "./Image/next_n.gif";
import next_o from "./Image/next_o.gif";
import next_d from "./Image/next_d.gif";
import ok_n from "./Image/ok_n.gif";
import ok_o from "./Image/ok_o.gif";
import ok_d from "./Image/ok_d.gif";
import done_o from "./Image/done_o.gif";
import done_n from "./Image/done_n.gif";
import x_close_btn_n from "./Image/x_close_btn_n.png";
import x_close_btn_o from "./Image/x_close_btn_o.png";
import next_step_btn_n from "./Image/next_step_btn_n.png";
import next_step_btn_o from "./Image/next_step_btn_o.png";
import got_it_btn_n from "./Image/got_it_btn_n.png";
import got_it_btn_o from "./Image/got_it_btn_o.png";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';

export interface AnswerRef {
  getAnswer: () => {
    marks: number;
    noOfOptions: number;
    enteredCorrectAnswer: string;
    enteredWrongAnswer: string;
    enteredBlankAnswer: string;
    scoringMethod?: number | null;
    optOrder?: string;
  } | null;
}

interface FQnsProps {
  lessonMeta?: any;
  questionHtml: string;
  currentPage: number;
  totalPages: number;
  goToNextPage?: (e: React.MouseEvent) => void;
  showAlert: (message: string) => void;
  correctAudio: string[];
  incorrectAudio: string[];
  assetsBaseUrl?: string;
  sessionId: number | null;
  isCompleting?: boolean;
  updateSessionPoints?: (pointsEarned: number) => void;
  hwid?: number | null;
  subject?: string;
}

const FQns: React.ForwardRefRenderFunction<AnswerRef, FQnsProps> = (props, ref) => {
  const { lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, showAlert, correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints, hwid, subject } = props;
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const folderParam = params.get('folder');
  const lessonName = params.get('name');
  const diccode = params.get('diccode');
  const calledFrom = params.get('calledFrom');
  const [backSrc, setBackSrc] = useState(back_n);
  const [nextSrc, setNextSrc] = useState(next_n);
  const [okSrc, setOkSrc] = useState(ok_n);
  const [doneSrc, setDoneSrc] = useState(done_n);
  const [solutionSrc, setSolutionSrc] = useState(solution_n);
  const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
  const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
  const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);

  const [okClicked, setOkClicked] = useState(false);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const solnIframeRef = useRef<HTMLIFrameElement>(null);
  const [isNumberPad, setIsNumberPad] = useState(false);
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTyping, setIsTyping] = useState(false);

  const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);
  const [showClueModal, setShowClueModal] = useState(false);
  const [solutionSeen, setSolutionSeen] = useState<string | number>('N');
  const [clueContent,
    setClueContent
  ] = useState('');
  const [isClueLoading,
    setIsClueLoading
  ] = useState(false);
  const [noOfClues, setNoOfClues] = useState(0);
  const [currentClueNo, setCurrentClueNo] = useState(0);
  const [clueSeen, setClueSeen] = useState(false);
  const clueIframeRef = useRef<HTMLIFrameElement>(null);
  const prcIframeRef = useRef<HTMLIFrameElement>(null);
  const [showPrcModal, setShowPrcModal] = useState(false);
  const [prcContent,
    setPrcContent
  ] = useState("");
  const [isPrcLoading,
    setIsPrcLoading
  ] = useState(false);
  const [prcSeen, setPrcSeen] = useState(false);
  const [principleList, setPrincipleList] = useState<string[]>([]);
  const [currentPrcIndex, setCurrentPrcIndex] = useState(0);
  const [showSolnModal, setShowSolnModal] = useState(false);
  const [isSolnLoading,
    setIsSolnLoading
  ] = useState(false);
  const [solnContent,
    setSolnContent
  ] = useState("");
  const [currentSolnNo, setCurrentSolnNo] = useState(0);
  const [noOfSteps, setNoOfSteps] = useState(0);
  const isInAssessment = window.location.href.includes('Assessment');

  useEffect(() => {
    setOkClicked(false);
    setAnswers({});
    setStartTime(new Date());
    setSolutionSeen('N');
    setClueSeen(false);
    setPrcSeen(false);
  }, [currentPage, questionHtml]);

  useEffect(() => {
    if (questionHtml) {
      const hasNumpad = questionHtml.includes('id="KSD_NUMPAD"');
      setIsNumberPad(hasNumpad);

      const infoMatch = questionHtml.match(/id="KSD_MW_Info"[^>]*value="([^"]*)"/i);
      let typeIsTyping = false;
      if (infoMatch && infoMatch[1]) {
        const parts = infoMatch[1].split('|');
        if (parts.length > 3 && parts[3] === '0' && !hasNumpad) {
          typeIsTyping = true;
        }
      }
      setIsTyping(typeIsTyping);
    }
  }, [questionHtml]);

  useEffect(() => {
    if (lessonMeta && Array.isArray(lessonMeta.qns) && currentPage <= lessonMeta.qns.length) {
      setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
    } else {
      setCurrentQnMeta(null);
    }
  }, [currentPage, lessonMeta]);

  const handleSolnClick = useCallback(async (autoExpand = false) => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowSolnModal(true);
    setIsSolnLoading(true);
    setSolnContent("");
    setCurrentSolnNo(0);
    setNoOfSteps(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = searchParams.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsSolnLoading(false);
      setShowSolnModal(false);
      return;
    }

    const accessToken = sessionStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in sessionStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}api/solution/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          autoExpand: autoExpand,
        }),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          showAlert("Authentication failed. Please log in again.");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSolnContent(data.solutionHtml || "");
      if (solutionSeen === 'N') {
        setSolutionSeen(1);
      }

    } catch (error) {
      console.error("Error fetching solution:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
        showAlert("Failed to load the solution. Please try again.");
      }
      setShowSolnModal(false);
    } finally {
      setIsSolnLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

  useImperativeHandle(ref, () => ({
    getAnswer: () => {
      const iframeDoc = iframeRef.current?.contentDocument;
      if (!iframeDoc) return null;

      const config = isNumberPad
        ? { userAnswers: answers, correctAnswerSelector: "#KSD_BW", splitter: '|', targetSelector: 'input[id^="KSD_BLANK_"]' }
        : { userAnswers: answers, correctAnswerSelector: "#KSD_ANS", splitter: ',', targetSelector: '.blank-box' };

      const targets = Array.from(iframeDoc.querySelectorAll(config.targetSelector));
      const correctAnsEl = iframeDoc.querySelector(config.correctAnswerSelector) as HTMLInputElement | null;

      if (!correctAnsEl) {
        showAlert("Could not find answer key.");
        return null;
      }
      const correctAnswers = correctAnsEl.value.split(config.splitter);

      if (Object.values(config.userAnswers).filter(ans => ans?.trim() !== '').length < targets.length) {
        showAlert("Please answer the question.");
        return null;
      }

      let correctCount = 0;
      const enteredCorrect: string[] = [];
      const enteredWrong: string[] = [];

      targets.forEach((element, index) => {
        const userAnswer = config.userAnswers[element.id]?.trim() || '';
        const correctAnswer = correctAnswers[index]?.trim();
        if (userAnswer.toLowerCase() === correctAnswer.toLowerCase()) {
          correctCount++;
          enteredCorrect.push(userAnswer);
        } else {
          enteredWrong.push(userAnswer);
        }
      });

      const allCorrect = correctCount === targets.length;
      const marks = allCorrect ? 1 : 0;

      return {
        marks,
        noOfOptions: targets.length,
        enteredCorrectAnswer: enteredCorrect.join('|'),
        enteredWrongAnswer: enteredWrong.join('|'),
        enteredBlankAnswer: "",
        optOrder: "",
        scoringMethod: null
      };
    }
  }));

  const handleBackMouseOver = () => setBackSrc(back_o);
  const handleBackMouseOut = () => setBackSrc(back_n);
  const handleBackMouseDown = () => setBackSrc(back_d);
  const handleBackMouseUp = () => setBackSrc(back_o);
  const handleNextMouseOver = () => setNextSrc(next_o);
  const handleNextMouseOut = () => setNextSrc(next_n);
  const handleNextMouseDown = () => setNextSrc(next_d);
  const handleNextMouseUp = () => setNextSrc(next_o);
  const handleOkMouseOver = () => setOkSrc(ok_o);
  const handleOkMouseOut = () => setOkSrc(ok_n);
  const handleOkMouseDown = () => setOkSrc(ok_d);
  const handleOkMouseUp = () => setOkSrc(ok_o);
  const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
  const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
  const handleSolutionMouseDown = () => setSolutionSrc(solution_d);
  const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
  const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);
  const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
  const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
  const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
  const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);

  const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
    const accessToken = sessionStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    const response = await fetch(`${apiUrl}api/principle/`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        folder: folderParam,
        questionNo: principleId,
        country: countryParam,
      }),
    });

    if (!response.ok) throw new Error("Failed");
    return await response.json();
  };

  const handlePrcClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowPrcModal(true);
    setIsPrcLoading(true);
    setPrcContent("");

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsPrcLoading(false);
      setShowPrcModal(false);
      return;
    }

    const accessToken = sessionStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in sessionStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}api/principle/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          setPrcContent("");
        } else {
          if (response.status === 401 || response.status === 403) {
            showAlert("Authentication failed. Please log in again.");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } else {
        const data = await response.json();
        setPrcContent(data.principleHtml || "");
        setPrcSeen(true);
      }

    } catch (error) {
      console.error("Error fetching principle:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
        showAlert("Failed to load the principle. Please try again.");
      }
      setPrcContent("");
    } finally {
      setIsPrcLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const handleClueClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowClueModal(true);
    setIsClueLoading(true);
    setClueContent("");
    setCurrentClueNo(0);
    setNoOfClues(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';
    const varValuesParam = currentQnMeta?.VarValues || "";

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsClueLoading(false);
      setShowClueModal(false);
      return;
    }

    const accessToken = sessionStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in sessionStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}api/clue/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          varValues: varValuesParam,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          setClueContent("");
        } else {
          if (response.status === 401 || response.status === 403) {
            showAlert("Authentication failed. Please log in again.");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } else {
        const data = await response.json();
        setClueContent(data.clueHtml || "");
        setClueSeen(true);
      }

    } catch (error) {
      console.error("Error fetching clue:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
        showAlert("Failed to load the clue. Please try again.");
      }
      setClueContent("");
    } finally {
      setIsClueLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);


  const processAndInjectBridge = useCallback((html: string): string => {
    if (!html) return '';
    const infoMatch = html.match(/id="KSD_MW_Info"[^>]*value="([^"]*)"/i);
    const hasNumpad = html.includes('id="KSD_NUMPAD"');
    let isTypingLocal = false;

    if (infoMatch && infoMatch[1]) {
      const parts = infoMatch[1].split('|');
      if (parts.length > 3 && parts[3] === '0' && !hasNumpad) {
        isTypingLocal = true;
      }
    }
    const fixBrokenAudioHandlers = (html: string) => {
      return html.replace(
        /aud\.play\(\);\s*}}\s*catch/g,
        "aud.play(); } catch"
      );
    };

    let processedHtml = html.trim().startsWith('\ufeff')
      ? html.trim().substring(1)
      : html.trim();

    processedHtml = fixBrokenAudioHandlers(processedHtml);

    processedHtml = processedHtml.replace(/http:\/\//gi, "https://");
    processedHtml = processedHtml.replace(/on(mousemove|mouseup|mousedown|keypress|change|load)\s*=\s*(['"])(?:(?!\2).)*\2/gi, "");
    processedHtml = processedHtml.replace(/<script[\s\S]*?<\/script>/gi, "");
    const bwMatch = processedHtml.match(/<input[^>]*id="KSD_BW"[^>]*value="([^"]*)"/i);
    if (bwMatch) {
      const correctAnswers = bwMatch[1].split('|').join(',');
      const answerKeyInputHtml = `<input type="hidden" id="KSD_ANS" value="${correctAnswers}" />`;
      processedHtml = processedHtml.replace('</body>', answerKeyInputHtml + '</body>');
    }

    if (isTypingLocal) {
      processedHtml = processedHtml.replace(/(<input[^>]*id="KSD_BLANK_\d+"[^>]*?)(\s*on\w+="[^"]*")+/gi, '$1');

      const bridge = `
            <style>
              body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
              p { margin: 0; padding: 0; }
              table { border-collapse: collapse; }
              
              input[id^="KSD_BLANK_"] {
                  border: none !important;
                  border-bottom: 4px solid red !important;
                  background-color: transparent !important;
                  background-image: none !important;
                  text-align: center !important;
                  
                  font-family: Verdana, Arial, sans-serif !important;
                  font-size: 18pt !important;
                  color: #017ebc !important; 
                  font-weight: normal !important;
                  
                  outline: none !important;
                  min-width: 50px;
                  padding: 0 5px;
                  border-radius: 0 !important;
                  line-height: normal !important;
              }
              
              input[id^="KSD_BLANK_"]:focus {
                  border: none !important;
                  border-bottom: 4px solid red !important;
                  outline: 2px solid black !important;
                  border-radius: 2px !important;
                  background-color: transparent !important;
                  background-image: none !important;
                  box-shadow: none !important;
              }
            </style>
            <script>
              document.addEventListener('DOMContentLoaded', function() {
                const answers = {};
                function postAnswers() { parent.postMessage({ type: "el-fillin-answers", value: answers }, "*"); }
                
                const inputs = document.querySelectorAll('input[id^="KSD_BLANK_"]');
                inputs.forEach(input => {
                    if(input.value) answers[input.id] = input.value;
                    
                    input.setAttribute('autocomplete', 'off');
                    
                    const adjustWidth = () => {
                        const len = input.value.length;
                        input.style.width = (len > 3 ? len + 1 : 4) + 'ch';
                    };
                    adjustWidth();

                    input.addEventListener('input', (e) => {
                        answers[e.target.id] = e.target.value;
                        adjustWidth();
                        postAnswers();
                    });
                });
              });
            </script>`;

      return processedHtml.replace("</body>", bridge + "</body>");

    } else {
      processedHtml = processedHtml.replace(/<input[^>]*id="KSD_BLANK_(\d+)"[^>]*>/gi, '<span id="KSD_BLANK_$1" class="blank-box"></span>');

      const bridge = `
            <style>
              body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
              p { margin: 0; padding: 0; }
              table { border-collapse: collapse; }
              .blank-box { 
                  display: inline-flex; 
                  flex-direction: row; 
                  justify-content: center; 
                  align-items: center; 
                  min-width: 30px; 
                  width: auto; 
                  height: 30px; 
                  border: 2px solid black !important; 
                  font-family: Verdana, sans-serif; 
                  background-color: white; 
                  cursor: pointer;
                  font-size: 18pt; 
                  vertical-align: middle; 
                  padding: 2px 5px; 
                  color: #017ebc;
              }
              .blank-box.selected { border: 4px solid red !important; } 
              .blank-box.filled { }
            </style>
            <script>
              document.addEventListener('DOMContentLoaded', function() {
                try {
                  let activeBlank = null; let currentSelectedOption = null; const answers = {};
                  let normalBgUrl = ''; let selectedBgUrl = '';
                  const firstOption = document.querySelector('td[data-normal-bg]');
                  if (firstOption) { normalBgUrl = firstOption.getAttribute('data-normal-bg'); selectedBgUrl = firstOption.getAttribute('data-selected-bg'); } 

                  function postAnswers() { parent.postMessage({ type: "el-fillin-answers", value: answers }, "*"); }
                  
                  function updateBlankState(el) {
                    if (!el) return;
                    const len = el.textContent ? el.textContent.trim().length : 0;
                    if (len > 0) {
                        el.style.width = 'auto';
                        el.style.minWidth = 'auto';
                        el.classList.add('filled');
                    } else {
                        el.style.width = '50px';
                        el.classList.remove('filled');
                    }
                  }

                  const blanks = Array.from(document.querySelectorAll('.blank-box')).sort((a, b) => parseInt(a.id.split('_').pop() || '0') - parseInt(b.id.split('_').pop() || '0'));
                  function setActiveBlank(blank) { if (activeBlank) activeBlank.classList.remove('selected'); activeBlank = blank; if (activeBlank) activeBlank.classList.add('selected'); }
                  
                  if (blanks.length > 0) setActiveBlank(blanks[0]);
                  
                  blanks.forEach(blank => { 
                      updateBlankState(blank); 
                      blank.addEventListener('click', () => setActiveBlank(blank)); 
                  });

                  document.querySelectorAll('td[id^="KSD_FIGTD_"]').forEach(option => {
                      option.addEventListener('click', () => {
                          if (currentSelectedOption && currentSelectedOption !== option) { 
                              currentSelectedOption.style.backgroundImage = 'url(' + normalBgUrl + ')'; 
                          }
                          option.style.backgroundImage = 'url(' + selectedBgUrl + ')'; 
                          currentSelectedOption = option;
                          
                          if (activeBlank) {
                              const newAnswerValue = option.textContent.trim(); 
                              activeBlank.textContent = newAnswerValue;
                              
                              updateBlankState(activeBlank);
                              answers[activeBlank.id] = newAnswerValue; 
                              postAnswers();

                              const currentIndex = blanks.indexOf(activeBlank); 
                              if (currentIndex < blanks.length - 1) {
                                  setActiveBlank(blanks[currentIndex + 1]);
                              }
                          }
                      });
                  });
                } catch(e) { console.error("Bridge Error:", e); }
              });
            </script>`;
      return processedHtml.replace("</body>", bridge + "</body>");
    }
  }, []);

  const injectNumberPadBridge = (html: string): string => {

    const fixBrokenAudioHandlers = (html: string) => {
      return html.replace(
        /aud\.play\(\);\s*}}\s*catch/g,
        "aud.play(); } catch"
      );
    };

    let safeHtml = html.replace(/http:\/\//gi, "https://");
    safeHtml = fixBrokenAudioHandlers(safeHtml);
    let cleaned = safeHtml
      .replace(/on(mousemove|mouseup|mousedown|keypress|change|load)\s*=\s*(['"])(?:(?!\2).)*\2/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")


    const bridge = `
      <style>
        body {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          gap: 40px;
          height: 80vh;
        }
        p { margin: 0; padding: 0; }

        font {
          color: black;
        }

        input[id^="KSD_BLANK_"] {
          caret-color: #017EBC; 
          border: 2px solid rgb(56, 77, 100) !important;
          font-weight: normal !important;
          font-family: Verdana, sans-serif !important;
          text-align: center !important;
          color: #017EBC !important;
          font-size: 18pt !important; 
          min-width: 5ch;
        }
        
        input[id^="KSD_BLANK_"].active-input {
          outline: none;
          border: 4px solid red !important;
        }

        input[id^="KSD_BLANK_"]:focus {
          outline: 1px solid black !important;
          border: 4px solid red !important;
          border-radius: 5px;
        }
        
        table img[onclick] { 
          cursor: pointer; 
        }
      </style>
      <script>
        document.addEventListener('DOMContentLoaded', function() {
          try {
            try {
              const numPadContainer = document.getElementById('KSD_NUMPAD');
              
              if (numPadContainer) {
                const innerTable = numPadContainer.querySelector('table');
                
                if (innerTable) {
                  innerTable.style.marginTop = '0px';
                  innerTable.style.margin = '0px';
                  innerTable.style.borderSpacing = '0px';
                  innerTable.setAttribute('cellpadding', '0');

                  if (innerTable.rows.length > 0) {
                    const firstButtonRow = innerTable.rows[0];
                    const numCols = firstButtonRow.cells.length; 

                    const labelRow = innerTable.insertRow(0); 
                    
                    const labelCell = labelRow.insertCell(0);
                    labelCell.textContent = 'Number pad:';

                    labelCell.style.paddingBottom = '10px'; 
                    labelCell.style.fontFamily = 'arial'; 
                    labelCell.style.fontSize = '24pt'; 
                    labelCell.style.color = '#3c5168'; 
                    labelCell.style.fontWeight = 'normal'; 

                    if (numCols > 1) {
                      labelCell.colSpan = numCols;
                    }
                  }
                }
              } else {
                const numPadButton = document.querySelector('[onclick*="insertDigit"]');
                if (numPadButton) {
                  const innerTable = numPadButton.closest('table');
                  if (innerTable) {
                    innerTable.style.margin = '0px';
                    innerTable.style.marginTop = '0px';
                    innerTable.style.borderSpacing = '0px';
                    innerTable.setAttribute('cellpadding', '0');

                    if (innerTable.rows.length > 0) {
                      const firstButtonRow = innerTable.rows[0];
                      const numCols = firstButtonRow.cells.length;
                      const labelRow = innerTable.insertRow(0);
                      const labelCell = labelRow.insertCell(0);
                      labelCell.textContent = 'Number pad:';
                      labelCell.style.textAlign = 'left';
                      labelCell.style.paddingBottom = '10px';
                      labelCell.style.fontFamily = 'arial';
                      labelCell.style.fontSize = '24pt';
                      labelCell.style.color = '#3c5168';
                      labelCell.style.fontWeight = 'normal';
                      if (numCols > 1) {
                        labelCell.colSpan = numCols;
                      }
                    }
                  }
                }
              }
            } catch (e) {
              console.error('Error adding number pad label:', e);
            }


            let activeInput = null;
            const inputs = document.querySelectorAll('input[id^="KSD_BLANK_"]');

            function setActive(el) {
                activeInput = el;
                inputs.forEach(i => i.classList.remove('active-input'));
                el.classList.add('active-input');
            }

            if (inputs.length > 0) {
              setActive(inputs[0]);
              inputs[0].focus();
            }

            inputs.forEach(input => {
              input.style.width = Math.max(2, input.value.length) + 'ch';
              
              input.addEventListener('focus', function() { 
                  setActive(this);
              });
              
              input.addEventListener('input', function() {
                this.value = this.value.replace(/[^0-9 \\-+*/().]/g, '');
                const allAnswers = {};
                inputs.forEach(inp => { allAnswers[inp.id] = inp.value; });
                parent.postMessage({ type: 'el-fillin-answers', value: allAnswers }, '*');
                this.style.width = Math.max(2, this.value.length) + 'ch';
              });
            });
            
            window.insertDigit = function(digit) {
              if (!activeInput) return;
              
              if (digit === '←') {
                activeInput.value = activeInput.value.slice(0, -1);
              } else {
                activeInput.value += digit;
              }
              const event = new Event('input', { bubbles: true });
              activeInput.dispatchEvent(event);
            };

          } catch(e) { console.error("Number Pad Bridge Error:", e); }
        });
      </script>
    `;
    return cleaned.includes('</body>') ? cleaned.replace('</body>', bridge + '</body>') : cleaned + bridge;
  };

  // const injectNumberPadBridge = (html: string): string => {
  //   // 1. Clean legacy event handlers
  //   let cleaned = html
  //       .replace(/onmousemove="[^"]*"/gi, "")
  //       .replace(/onkeypress="[^"]*"/gi, "")
  //       .replace(/onchange="[^"]*"/gi, "")
  //       .replace(/<script[\s\S]*?<\/script>/gi, "")
  //       .replace(/(<td[^>]*id="KSD_TD_[^"]*"[^>]*)\s+style="[^"]*"/gi, "$1"); 

  //   const bridge = `
  //     <style>
  //       body {
  //         display: flex;
  //         justify-content: center;
  //         align-items: flex-start;
  //         gap: 40px;
  //         height: 80vh;
  //         font-family: Verdana, Arial, sans-serif;
  //       }

  //       /* We use !important here to reset the "Bad" inline styles coming from the legacy HTML 
  //          (e.g., text-align: left, border-bottom: red).
  //          The specific correct styles will be applied by the JS below.
  //       */
  //       input[id^="KSD_BLANK_"] {
  //         caret-color: #017EBC; 
  //         background-color: transparent;
  //         font-family: Verdana, Arial, sans-serif !important;
  //         font-size: 18pt !important; /* Force legacy size */
  //         text-align: center !important; /* Force center */
  //         padding: 2px 4px;
  //         transition: border 0.1s ease;
  //       }

  //       input[id^="KSD_BLANK_"]:focus {
  //         outline: none;
  //       }

  //       table img[onclick] { 
  //         cursor: pointer; 
  //       }
  //     </style>
  //     <script>
  //       document.addEventListener('DOMContentLoaded', function() {
  //         try {
  //           // --- 1. CONFIGURATION (EL_F.js Init_F Logic) ---
  //           var infoVal = document.getElementById("KSD_MW_Info") ? document.getElementById("KSD_MW_Info").value : "";
  //           var infoParts = infoVal.split("|");

  //           // Legacy Defaults
  //           var FGColor = infoParts[1] || "#017ebc"; 
  //           var BlankBorderStyle = (infoParts.length >= 9) ? infoParts[8] : "1"; // Default to Box (1) if undefined
  //           var BlankWidthSetting = (infoParts.length >= 14) ? parseInt(infoParts[13]) : 0;

  //           // Colors
  //           var BorderColorIdle = "#384D64"; 
  //           var BorderColorActive = "#ff0000"; 

  //           // --- 2. WIDTH CALCULATION (EL_F.js Logic) ---
  //           // Legacy calculates width based on the CORRECT ANSWER length, not the 'size' attribute.
  //           var correctAnsVal = document.getElementById("KSD_BW") ? document.getElementById("KSD_BW").value : "";
  //           var correctAnswers = correctAnsVal.split("|");
  //           var maxAnswerLength = 0;

  //           if (correctAnswers.length > 0) {
  //               correctAnswers.forEach(function(ans) {
  //                   if (ans.length > maxAnswerLength) maxAnswerLength = ans.length;
  //               });
  //           } else {
  //               maxAnswerLength = 5; // Fallback
  //           }

  //           // Calculate width: 50px base + 15px per character
  //           // e.g., Answer "49" (len 2) -> 50 + 30 = 80px.
  //           var finalWidth = (50 + (maxAnswerLength * 15)) + "px";

  //           if (BlankWidthSetting > 0) {
  //               finalWidth = BlankWidthSetting + "px";
  //           }

  //           // --- 3. HELPER: BORDER LOGIC ---
  //           function applyBorder(el, isActive) {
  //               var color = isActive ? BorderColorActive : BorderColorIdle;
  //               var width = isActive ? "4px" : "2px";

  //               // We directly overwrite style.border to kill inline "border-bottom: red"
  //               if (BlankBorderStyle === "0") {
  //                   el.style.border = "none";
  //                   el.style.borderBottom = width + " solid " + color;
  //               } else {
  //                   // Box Style (Default)
  //                   el.style.border = width + " solid " + color;
  //               }
  //           }

  //           // --- 4. INPUT INITIALIZATION ---
  //           let activeInput = null;
  //           const inputs = Array.from(document.querySelectorAll('input[id^="KSD_BLANK_"]'));

  //           inputs.sort((a, b) => {
  //               var idA = parseInt(a.id.split('_').pop());
  //               var idB = parseInt(b.id.split('_').pop());
  //               return idA - idB;
  //           });

  //           if (inputs.length > 0) {
  //             activeInput = inputs[0];
  //           }

  //           inputs.forEach(input => {
  //             // --- APPLY LEGACY OVERRIDES ---
  //             // This overwrites the "bad" inline styles from HTML (e.g. width: 125px from size=5)
  //             input.style.width = finalWidth;
  //             input.style.color = FGColor;
  //             input.setAttribute("maxlength", "200000"); // Legacy unlimited length

  //             // Apply Initial Border (Overwrite inline red border)
  //             applyBorder(input, false);

  //             // Events
  //             input.addEventListener('focus', function() { 
  //                 activeInput = this; 
  //                 applyBorder(this, true);
  //             });

  //             input.addEventListener('blur', function() { 
  //                 applyBorder(this, false);
  //             });

  //             input.addEventListener('input', function() {
  //               this.value = this.value.replace(/[^0-9 \\-+*/().]/g, '');

  //               const allAnswers = {};
  //               inputs.forEach(inp => { allAnswers[inp.id] = inp.value; });
  //               parent.postMessage({ type: 'el-fillin-answers', value: allAnswers }, '*');

  //               // Auto-Tab Logic (using calculated max length as a heuristic)
  //               if (this.value.length >= maxAnswerLength) {
  //                   let currentIndex = inputs.indexOf(this);
  //                   if (currentIndex < inputs.length - 1) {
  //                       let nextInput = inputs[currentIndex + 1];
  //                       if (nextInput) nextInput.focus();
  //                   }
  //               }
  //             });
  //           });

  //           // --- 5. NUMPAD ---
  //           window.insertDigit = function(digit) {
  //             if (!activeInput) return;

  //             if (digit === '←') {
  //               activeInput.value = activeInput.value.slice(0, -1);
  //             } else {
  //               activeInput.value += digit;
  //             }

  //             const event = new Event('input', { bubbles: true });
  //             activeInput.dispatchEvent(event);
  //             activeInput.focus();
  //           };

  //           // --- 6. LEGACY NUMPAD TABLE FIX ---
  //           try {
  //             const numPadContainer = document.getElementById('KSD_NUMPAD');
  //             if (numPadContainer) {
  //               const innerTable = numPadContainer.querySelector('table');
  //               if (innerTable) {
  //                 innerTable.style.marginTop = '0px';
  //                 innerTable.style.borderSpacing = '0px';
  //                 if (innerTable.rows.length > 0) {
  //                   const firstRowText = innerTable.rows[0].innerText.toLowerCase();
  //                   if(!firstRowText.includes("number pad")) {
  //                       const numCols = innerTable.rows[0].cells.length; 
  //                       const labelRow = innerTable.insertRow(0); 
  //                       const labelCell = labelRow.insertCell(0);
  //                       labelCell.textContent = 'Number pad:';
  //                       labelCell.style.paddingBottom = '10px'; 
  //                       labelCell.style.fontFamily = 'arial'; 
  //                       labelCell.style.fontSize = '24pt'; 
  //                       labelCell.style.color = '#3c5168'; 
  //                       if (numCols > 1) labelCell.colSpan = numCols;
  //                   }
  //                 }
  //               }
  //             }
  //           } catch (e) { console.error('Error styling number pad:', e); }

  //         } catch(e) { console.error("Bridge Error:", e); }
  //       });
  //     </script>
  //   `;
  //   return cleaned.includes('</body>') ? cleaned.replace('</body>', bridge + '</body>') : cleaned + bridge;
  // };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && questionHtml) {
      const finalHtml = isNumberPad
        ? injectNumberPadBridge(questionHtml)
        : processAndInjectBridge(questionHtml);

      console.log(finalHtml);
      if (finalHtml.includes("audio_typenum_mp3")) {
        console.log("FOUND AUDIO HTML");
        console.log(finalHtml);
      }

      iframe.srcdoc = finalHtml;
    }
  }, [questionHtml, isNumberPad, processAndInjectBridge]);

  const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
    console.log("playRandomSound called");
    const baseUrl = assetsBaseUrl || "https://www.elearnoncloud.com/Storage/assets/";
    if (!soundFiles || soundFiles.length === 0) return;
    const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
    const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;
    console.log("audioUrl =", audioUrl);

    const audio = new Audio(audioUrl);
    try { await audio.play(); console.log("audio started"); } catch (error) { console.error(`Error playing audio from ${audioUrl}:`, error); }
  }, [assetsBaseUrl]);

  const handleDbUpdate = useCallback((payload: QuestionPerformancePayload) => {
    return saveQuestionPerformance(payload)
      .then((data) => {
        if (isCompleting && updateSessionPoints) {
          updateSessionPoints(data.pointsEarned || 0);
        }
        return data;
      })
      .catch((error) => {
        console.error("Save Performance Error:", error);
        throw error;
      });
  }, [isCompleting, updateSessionPoints]);

  const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
    e.preventDefault();
    if (okClicked || isSubmitting) return;

    const iframe = iframeRef.current;
    if (!iframe?.contentDocument) return;
    const iframeDoc = iframe.contentDocument;

    const config = (isNumberPad || isTyping)
      ? {
        userAnswers: answers,
        correctAnswerSelector: "#KSD_BW",
        splitter: '|',
        targetSelector: 'input[id^="KSD_BLANK_"]',
        isInput: true
      }
      : {
        userAnswers: answers,
        correctAnswerSelector: "#KSD_ANS",
        splitter: ',',
        targetSelector: '.blank-box',
        isInput: false
      };

    const targets = Array.from(iframeDoc.querySelectorAll(config.targetSelector)).sort((a, b) => parseInt(a.id.split('_').pop() || '0') - parseInt(b.id.split('_').pop() || '0'));
    const correctAnsEl = iframeDoc.querySelector(config.correctAnswerSelector) as HTMLInputElement | null;

    if (!correctAnsEl) {
      showAlert("Could not find answer key.");
      return;
    }
    const correctAnswers = correctAnsEl.value.split(config.splitter);

    if (Object.values(config.userAnswers).filter(ans => ans?.trim() !== '').length < targets.length) {
      showAlert("Please answer the question.");
      return;
    }

    let correctCount = 0;
    const enteredCorrect: string[] = [];
    const enteredWrong: string[] = [];

    targets.forEach((element, index) => {
      const el = element as HTMLElement;
      const userAnswer = config.userAnswers[el.id]?.trim() || '';
      const correctAnswer = correctAnswers[index]?.trim();

      if (userAnswer.toLowerCase() === correctAnswer.toLowerCase()) {
        correctCount++;
        enteredCorrect.push(userAnswer);
      } else {
        enteredWrong.push(userAnswer);
      }
    });

    const allCorrect = correctCount === targets.length;
    const marks = allCorrect ? 1 : 0;
    const noOfOptions = targets.length;

    const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;

    const payload: QuestionPerformancePayload = {
      schoolCode: sessionStorage.getItem('SchoolCode') || '',
      familyCode: sessionStorage.getItem('FamilyCode') || '',
      login: sessionStorage.getItem('Login') || '',
      dicCode: sessionStorage.getItem('SelectedDICFile') || '',
      lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
      sessionId: sessionId || 1,
      qnNo: currentQnMeta?.QnNo,
      subNo: 0,
      qnType: currentQnMeta?.QnType,
      marks: marks,
      noOfOptions: noOfOptions,
      enteredCorrectAnswer: enteredCorrect.join('|'),
      enteredWrongAnswer: enteredWrong.join('|'),
      enteredBlankAnswer: "",
      solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
      clueSeen: clueSeen,
      principleSeen: prcSeen,
      questionLoadTime: 0,
      questionAnswerTime: questionAnswerTime,
      lastQnInd: currentQnMeta?.LastQnInd || currentPage,
      allQuestionsCompleted: isCompleting ? 'True' : 'False',
      chapterCode: sessionStorage.getItem('ChapterCode') || '',
      unitCode: sessionStorage.getItem('UnitCode') || '',
      hwid: hwid,
      subject: subject
    };

    const isLastQuestion = currentPage === totalPages;

    if (isLastQuestion) {
      setIsSubmitting(true);
      try {
        await handleDbUpdate(payload);
      } catch (e) {
        console.error("Final submit failed", e);
        showAlert("Error saving progress. Please try again.");
        setIsSubmitting(false);
        return;
      }
      setIsSubmitting(false);
    } else {
      handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
    }

    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";

    targets.forEach((element, index) => {
      const el = element as HTMLElement;
      const userAnswer = config.userAnswers[el.id]?.trim() || '';
      const correctAnswer = correctAnswers[index]?.trim();
      const isEntryCorrect = userAnswer.toLowerCase() === correctAnswer.toLowerCase();

      let feedbackHtml = '';
      let borderStyle = 'border: none;';

      if (isEntryCorrect) {
        feedbackHtml = `
            <span style="position: relative; display: inline-block;">
              <span style="color: green; font-family: Verdana, sans-serif; font-weight: normal;">${userAnswer}</span>
              <img src="${CORRECT_URL}" alt="Correct" style="vertical-align: middle; margin-left: 5px;" />
            </span>`;
      } else {
        feedbackHtml = `
            <span style="color: red; text-decoration: line-through; font-family: Verdana, sans-serif;">${userAnswer}</span>
            <span style="color: green; margin-left: 0px; font-family: Verdana, sans-serif;">${correctAnswer}</span>`;
        borderStyle = 'border-bottom: 2px solid red;';
      }

      if (config.isInput) {
        const span = document.createElement('span');
        span.innerHTML = feedbackHtml;
        if (!isEntryCorrect) {
          span.style.borderBottom = '2px solid red';
          span.style.display = 'inline-block';
        }
        el.parentNode?.replaceChild(span, el);
      } else {
        el.className = '';
        el.style.cssText = `display: inline-block; ${borderStyle} background: transparent; padding: 0; margin: 0; width: auto; min-width: 0;`;
        el.innerHTML = feedbackHtml;
      }
    });

    const infoInput = iframeDoc.getElementById('KSD_MW_Info') as HTMLInputElement;
    let explanationHtml = "";

    if (infoInput && infoInput.value) {
      const parts = infoInput.value.split('|');
      if (marks === 1) {
        if (parts.length > 14 && parts[14]) explanationHtml = parts[14];
      } else {
        if (parts.length > 15 && parts[15]) explanationHtml = parts[15];
      }
    }

    if (explanationHtml && !iframeDoc.getElementById("el-explanation-container")) {
      const container = iframeDoc.createElement("div");
      container.id = "el-explanation-container";
      container.innerHTML = `
            <hr style='height:1px; background-color:#cfcfcf; border:none; margin-top:50px; margin-bottom:30px; margin-left:30px; margin-right:30px;'>
            <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:20px'>Explanation</p>
            <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:50px'>
                ${explanationHtml}
            </p>
        `;
      iframeDoc.body.appendChild(container);
      setTimeout(() => {
        iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight;
      }, 100);
    }

    if (allCorrect) {
      playRandomSound(correctAudio, 'Correct');
    } else {
      playRandomSound(incorrectAudio, 'Incorrect');
      if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
        handleSolnClick(true);
      }
    }

    setOkClicked(true);

  }, [answers, handleSolnClick, showAlert, isNumberPad, correctAudio, incorrectAudio, playRandomSound, startTime, lessonMeta, currentQnMeta, currentPage, totalPages, sessionId, isCompleting, handleDbUpdate, hwid, subject]);

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.data?.type === "el-fillin-answers") setAnswers(event.data.value);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);

  const handleBack = () => {
    const calledFrom = params.get("calledFrom");

    // console.log("calledFrom:", calledFrom);
    if (calledFrom) {
      const redirectPath = decodeURIComponent(calledFrom);
      window.location.href = redirectPath;
    }
    else if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <>
      {!isInAssessment && (
        <tr id="trQnButtons">
          <td className="QnPanelT">
            {/* <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
            <tbody>
              <tr id="trQnOK" className="trQnOKT">
                <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                <td id="QnPanelId2T" className="QnPanel">
                          <div 
                            onClick={!okClicked ? handleBack : undefined}
                            style={{ display: okClicked ? 'none' : 'block', cursor: 'pointer' }}
                          >
                            <div id="imgbtnBack" className="imgbtnBackT">
                              <img
                                src={backSrc}
                                alt="Back"
                                onMouseOver={handleBackMouseOver}
                                onMouseOut={handleBackMouseOut}
                                onMouseDown={handleBackMouseDown}
                                onMouseUp={handleBackMouseUp}
                                className="imgbtnBack2T"
                              />
                            </div>
                          </div>
                        </td>
                      <td id="QnPanelId3T" className="QnPanel">
                          <input
                            type="image"
                            id="imgPrc"
                            src={principle_n}
                            className="imgPrcT"
                            alt="Principle"
                            style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'inline-block' : 'none' }}
                            onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                          />
                        </td>
                            <td id="QnPanelId4T" className="QnPanel">
                      <input
                        type="image"
                        id="imgClue"
                        src={clue_n}
                        className="imgClueT"
                        alt="Clue"
                        style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'inline-block' : 'none' }}
                        onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                      />
                    </td>
                <td id="QnPanelId5T" className="QnPanel">
                  <input
                    type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution"
                    style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                    onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                    onMouseOver={handleSolutionMouseOver}
                    onMouseOut={handleSolutionMouseOut}
                    onMouseDown={handleSolutionMouseDown}
                  />
                </td>
                <td id="QnPanelId5T" className="QnPanel">
                  <a 
                    href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`} 
                    id="imgbtnTut" 
                    className="imgbtnTutT" 
                    style={{ display: okClicked ? 'none' : 'inline-block' }}
                  >
                    <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                  </a>
                </td>
                <td id="QnPanelId6T" className="QnPanel">
                  {isSubmitting ? (
                    <Loading />
                  ) : okClicked ? (
                    currentPage === totalPages ? (
                        <img 
                          src={doneSrc} 
                          alt="Done" 
                          style={{ verticalAlign: 'middle' }}
                          onClick={() => {
                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                            const calledFrom = params.get("calledFrom") || "";
                            navigate(
                                `/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson` +
                                (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : "")
                            );
                          }} 
                          onMouseOver={() => setDoneSrc(done_o)}
                          onMouseOut={() => setDoneSrc(done_n)}
                        />
                    ) : (
                        <img src={nextSrc} alt="Next" onClick={goToNextPage} onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut}
                        onMouseDown={handleNextMouseDown} onMouseUp={handleNextMouseUp} style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }}/>
                    )
                  ) : (
                    <div onClick={handleOkClick} onMouseOver={handleOkMouseOver} onMouseOut={handleOkMouseOut}
                      onMouseDown={handleOkMouseDown} onMouseUp={handleOkMouseUp} style={{ display: 'inline-block', cursor: 'pointer' }}>
                      <img src={okSrc} alt="OK" style={{ marginTop: '5px' }} />
                    </div>
                  )}
                </td>
                <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
              </tr>
              
              <tr id="trQnNext" className="trQnNextT">
                <td id="tdBN1" className="QnPanel">&nbsp;</td>
                <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                <td id="tdAnsSoln" className="QnPanel">
                  <img id="imgSolnAfterAnswering" src={solutionSrc} alt="Solution" onMouseOver={handleSolutionMouseOver}
                    onMouseOut={handleSolutionMouseOut} onMouseDown={handleSolutionMouseDown} onClick={(e) => { e.preventDefault(); handleSolnClick(); }}/>
                </td>
                <td id="tdQnNext" className="QnPanel">
                  {okClicked ? (
                    <input type="image" id="imgNextQuestion" src={nextSrc} alt="Next" onClick={goToNextPage}
                      onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut} onMouseDown={handleNextMouseDown}
                      onMouseUp={handleNextMouseUp} style={{ display: okClicked ? 'inline-block' : 'none' }} />
                  ) : (
                    <img id="imgOK" src={okSrc} alt="OK" onClick={handleOkClick} onMouseOver={handleOkMouseOver}
                      onMouseOut={handleOkMouseOut} onMouseDown={handleOkMouseDown} onMouseUp={handleOkMouseUp} className="imgOKT" style={{ display: okClicked ? 'none' : 'inline-block' }} />
                  )}
                </td>
                <td id="tdBN" className="QnPanel">&nbsp;</td>
              </tr>
            </tbody>
          </table> */}
          </td>
        </tr>
      )}

      <tr id="triFrame">
        <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
          <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
            {questionHtml ? (
              <iframe
                id="iFrameQn"
                ref={iframeRef}
                frameBorder={0}
                scrolling="yes"
                className="CssiFrm"
                style={{
                  flex: '1 1 0',
                  width: '100%',
                  height: '100%',
                  minHeight: 0,
                  border: 'none',
                  overflow: 'auto'
                }}
                title="Question Page"
              />
            ) : <Loading />}
          </div>
        </td>
      </tr>

      {showClueModal && (
        <>
          {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}
          <div id="divClue" style={{ display: 'block' }}>
            <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
              <tbody>
                <tr>
                  <td id="tdClueTitle1" align="left">Clue</td>
                  <td id="tdClueClose" align="right" valign="top">
                    <img
                      id="imgClueClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => setShowClueModal(false)}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div id="divFrameClue">
              {isClueLoading ? <Loading /> : (
                <iframe
                  id="iFrameClue"
                  ref={clueIframeRef}
                  title="Clue"
                  srcDoc={clueContent}
                  style={{ width: '100%', border: 'none', minHeight: '80px' }}
                  onLoad={() => {
                    // console.log("Clue iframe onLoad event fired.");
                    const iframe = clueIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) { return; }
                    try {
                      const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                      divShows.forEach(div => {
                        (div as HTMLElement).style.padding = "20px";
                      });
                      const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                      const totalClues = parseInt(cluesInput?.value || '0', 10);
                      setNoOfClues(totalClues);
                      const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                      clueDivs.forEach((div, index) => {
                        div.style.display = index === 0 ? 'block' : 'none';
                      });
                      const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                      if (firstClueDiv) {
                        const newHeight = firstClueDiv.scrollHeight;
                        iframe.style.height = `${Math.min(newHeight, 300)}px`;
                      } else if (totalClues === 0) {
                        iframe.style.height = '50px';
                      }
                    } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                  }}
                />
              )}
            </div>
            <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
              <tbody>
                <tr>
                  <td style={{ width: '33%' }}>&nbsp;</td>
                  <td style={{ width: '34%' }}>&nbsp;</td>
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                      <img
                        id="btnClueNext"
                        src={NextStepBtnSrc}
                        alt="Next Clue"
                        onClick={() => {
                          const nextClue = currentClueNo + 1;
                          const iframe = clueIframeRef.current;
                          if (iframe?.contentDocument) {
                            iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                              div.style.display = index === nextClue ? 'block' : 'none';
                            });
                            setCurrentClueNo(nextClue);
                            const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                            if (nextClueDiv) {
                              const newHeight = nextClueDiv.scrollHeight + 20;
                              iframe.style.height = `${Math.min(newHeight, 300)}px`;
                            }
                          }
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                    {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                      <img
                        id="btnClueGotIt"
                        src={GotItBtnSrc}
                        alt="Got It"
                        onClick={() => setShowClueModal(false)}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {showPrcModal && (
        <>
          <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

          <div id="divPCS" style={{ display: 'block' }} className="principle">

            {/* Header */}
            <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
              <tbody>
                <tr>
                  <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                    Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                  </td>
                  <td id="tdPCSClose" align="right" valign="top">
                    <img
                      id="imgPCSClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Body */}
            <div id="divFramePCS">
              {isPrcLoading ? <Loading /> : (
                <iframe
                  id="iFramePrc"
                  ref={prcIframeRef}
                  title="Prc"
                  srcDoc={prcContent}
                  style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                  onLoad={() => {
                    const iframe = prcIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                    setTimeout(() => {
                      if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                      const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                      const divPCS = document.getElementById('divPCS') as HTMLElement;
                      const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                      const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                      if (divPCS && titleTable && navTable) {
                        const maxModalHeight = window.innerHeight * 0.8;
                        const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                        if (contentHeight > maxIframeHeight) {

                          iframe.style.height = `${maxIframeHeight}px`;
                          iframe.style.overflowY = 'auto';
                        } else {

                          iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                          iframe.style.overflowY = 'hidden';
                        }
                      } else {
                        iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                      }
                    }, 50);
                  }}
                />
              )}
            </div>

            {/* Footer / Navigation */}
            <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px' }}>
              <tbody>
                <tr style={{ backgroundColor: '#F2F2F2' }}>
                  {/* Previous Button */}
                  <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                    {currentPrcIndex > 0 && (
                      <input
                        type='button'
                        value='PREVIOUS'
                        onClick={() => {
                          const prevIndex = currentPrcIndex - 1;
                          setCurrentPrcIndex(prevIndex);
                          const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                          const countryParam = params.get('country') || 'Australia';
                          fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                        }}
                        style={{
                          fontWeight: 'bold',
                          color: 'White',
                          fontSize: '12pt',
                          borderStyle: 'none',
                          backgroundColor: 'maroon',
                          cursor: 'pointer',
                          padding: '5px 10px'
                        }}
                      />
                    )}
                  </td>

                  <td style={{ width: '34%' }}>&nbsp;</td>

                  {/* Next / Got It Button */}
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {currentPrcIndex < principleList.length - 1 ? (
                      <img
                        src={NextStepBtnSrc}
                        alt="Next"
                        onClick={() => {
                          const nextIndex = currentPrcIndex + 1;
                          setCurrentPrcIndex(nextIndex);
                          const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                          const countryParam = params.get('country') || 'Australia';
                          fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                      />
                    ) : (
                      <img
                        src={GotItBtnSrc}
                        id="imgGotIt"
                        alt="Got It"
                        onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {showSolnModal && (
        <>
          <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
            setShowSolnModal(false);
            setCurrentSolnNo(0);
          }}></div>

          <div id="divPCS" style={{ display: 'block', position: 'fixed', bottom: '0', width: '100%', zIndex: 10000 }}>
            <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
              <tbody>
                <tr>
                  <td id="tdPCSTitle1">Step by step solution</td>
                  <td id="tdPCSClose" align="right" valign="top">
                    <img
                      id="imgPCSClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => {
                        setShowSolnModal(false);
                        setCurrentSolnNo(0);
                      }}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div id="divFramePCS">
              {isSolnLoading ? <Loading /> : (
                <iframe
                  id="iFrameSolution"
                  ref={solnIframeRef}
                  title="Solution"
                  srcDoc={solnContent}
                  style={{ width: '100%', border: 'none', minHeight: '50px' }}
                  onLoad={() => {
                    const iframe = solnIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                      console.error("Iframe document or window not ready in onLoad.");
                      return;
                    }
                    try {
                      const iframeDoc = iframe.contentDocument;
                      const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                      const totalSteps = parseInt(stepsInput?.value || '0', 10);
                      setNoOfSteps(totalSteps);

                      const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                      const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');

                      stepRows.forEach((step, index) => {
                        if (index === 0 || isAutoExpanded) {
                          step.style.display = 'table-row';
                        } else {
                          step.style.display = 'none';
                        }
                      });

                      if (totalSteps === 0) {
                        iframe.style.height = '50px';
                      }

                      setTimeout(() => {
                        if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                        const contentHeight = iframe.contentDocument.body.scrollHeight + 5;

                        const divPCS = document.getElementById('divPCS') as HTMLElement;
                        const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                        const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                        if (divPCS && titleTable && navTable) {
                          const maxModalHeight = window.innerHeight * 0.45;
                          const currentModalHeight = divPCS.offsetHeight;
                          const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                          if (contentHeight > maxIframeHeight) {
                            iframe.style.height = `${maxIframeHeight}px`;
                            iframe.style.overflowY = 'auto';
                          } else {
                            iframe.style.height = `${Math.max(contentHeight, 50)}px`;
                            iframe.style.overflowY = 'hidden';
                          }
                        }

                        if (isAutoExpanded) {
                          setCurrentSolnNo(totalSteps - 1);
                          if (solutionSeen !== 'Y') {
                            setSolutionSeen('Y');
                          }
                          iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                        } else {
                          iframe.contentWindow?.scrollTo(0, 0);
                        }
                      }, 50);

                      iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                        img.onclick = () => {
                          const index = img.id.substring(6);
                          const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                          const content = ksdDiv?.getAttribute('data-ksd-content');
                          const parentTd = img.closest('td');
                          if (content && parentTd && img.getAttribute('alt') === '1') {
                            parentTd.innerHTML = content;
                            img.setAttribute('alt', '2');
                          }
                        };
                      });

                    } catch (e) {
                      console.error("Error inside solution iframe onLoad:", e);
                    }
                  }}
                />
              )}
            </div>

            <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
              <tbody>
                <tr>
                  <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                  </td>

                  <td align="center" style={{ width: '34%' }}>
                    &nbsp;
                  </td>

                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                      <img
                        id="btnPCSNext"
                        src={NextStepBtnSrc}
                        alt="Next Step"
                        onClick={() => {
                          const nextStep = currentSolnNo + 1;
                          const iframe = solnIframeRef.current;

                          if (iframe?.contentDocument?.body) {
                            const iframeDoc = iframe.contentDocument;

                            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                            if (nextStep >= stepRows.length) return;

                            const nextStepElement = stepRows[nextStep];
                            nextStepElement.style.display = 'table-row';

                            setTimeout(() => {
                              if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                              const totalRequiredHeight = iframe.contentDocument.body.scrollHeight + 5;

                              const divPCS = document.getElementById('divPCS') as HTMLElement;
                              const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                              const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                              if (!divPCS || !titleTable || !navTable) return;

                              const maxModalHeight = window.innerHeight * 0.45;
                              const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                              const maxAllowedIframeHeight = maxModalHeight - chromeHeight;

                              if (totalRequiredHeight > maxAllowedIframeHeight) {
                                iframe.style.height = `${maxAllowedIframeHeight}px`;
                                iframe.style.overflowY = 'auto';
                              } else {
                                iframe.style.height = `${totalRequiredHeight}px`;
                                iframe.style.overflowY = 'hidden';
                              }

                              iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                            }, 50);

                            setCurrentSolnNo(nextStep);
                            if (solutionSeen !== 'Y') {
                              setSolutionSeen(nextStep + 1);
                            }
                          }
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer' }}
                      />
                    )}

                    {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                      <img
                        id="btnPCSClose"
                        src={GotItBtnSrc}
                        alt="Got It"
                        onClick={() => {
                          setShowSolnModal(false);
                          setCurrentSolnNo(0);
                          setSolutionSeen('Y');
                        }}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default forwardRef(FQns);